import { Box } from '@mui/system';
import React from 'react';

const CenteredFullHeightContainer = ({ children, sx, ...otherProps }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh', ...sx }} {...otherProps}>
            {children}
        </Box>
    );
};

export default CenteredFullHeightContainer;